import { Button, Table as ChakraTable } from "@chakra-ui/react";
import GenericTable from "@/components/GenericTable";
import GenericTableElement from "@/components/GenericTableElement";
import { usePermissions } from "@/hooks/usePermissions";
import {
  SCREENING_TABLE_COLUMNS,
  canCreateContract,
  formatDocument,
} from "../columns";
import { propertyUseLabels } from "../mappers/screening.mapper";
import { Screening } from "../types";
import SourceBadge from "./SourceBadge";
import StatusBadge from "./StatusBadge";

type Props = {
  isLoading: boolean;
  screenings: Screening[];
  onSelect: (screening: Screening) => void;
  onCreateContract: (screening: Screening) => void;
};

const Table = ({
  isLoading,
  screenings,
  onSelect,
  onCreateContract,
}: Props): JSX.Element => {
  const { isEditor } = usePermissions();

  return (
    <GenericTable
      isLoading={isLoading}
      columns={SCREENING_TABLE_COLUMNS}
      interactive
      size="sm"
    >
      {screenings.map((screening) => (
        <ChakraTable.Row
          key={screening.id}
          cursor="pointer"
          onClick={() => onSelect(screening)}
        >
          <GenericTableElement value={formatDocument(screening)} />
          <GenericTableElement value={screening.tenantName} />
          <GenericTableElement value={screening.propertyAddress} />
          <GenericTableElement
            value={
              screening.propertyUse
                ? propertyUseLabels[screening.propertyUse]
                : undefined
            }
          />
          <GenericTableElement value={screening.monthlyRent} formatNumber />
          <GenericTableElement
            value={screening.status}
            actions={<StatusBadge status={screening.status} />}
          />
          <GenericTableElement
            value={screening.source}
            actions={<SourceBadge source={screening.source} />}
          />
          <GenericTableElement value={screening.createdAt} formatDatetimeUtc />
          <GenericTableElement
            value={undefined}
            actions={
              isEditor &&
              canCreateContract(screening) && (
                <Button
                  size="xs"
                  variant="outline"
                  onClick={(e) => {
                    e.stopPropagation();
                    onCreateContract(screening);
                  }}
                >
                  Ingresar
                </Button>
              )
            }
          />
        </ChakraTable.Row>
      ))}
    </GenericTable>
  );
};

export default Table;
